import React, {FC} from "react"

import Button from "@irati/ui/src/Button"
import GenericModal from "@irati/ui/src/GenericModal"
import {H2, Body} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {Img} from "../../SetupInformation/styled"

interface Props extends InjectIntl {
  show: boolean
  text: string
  button: string
  submit?: Promise<void> | null
  showSuccess?: boolean
  onConfirm: () => void
  onHide: () => void
}

const InvitationEmailsModal: FC<Props> = ({show, text, button, showSuccess, submit, onConfirm, onHide, formatMessage}) => {
  return (
    <GenericModal hideActions show={show} onHide={onHide}>
      {showSuccess ? (
        <>
          <H2 marginBottom={1}>
            <FormattedMessage id="admin.components.integrations.dsyncSetup.invitationEmailsmodal.title" />
          </H2>
          <Body marginBottom={3}>
            <FormattedMessage id="admin.components.integrations.dsyncSetup.invitationEmailsmodal.success" />
          </Body>
          <Flex alignItems="center">
            <Img src={formatMessage({id: "admin.components.integrations.dsyncSetup.invitationEmailsmodal.img"})} />
          </Flex>
        </>
      ) : (
        <>
          <H2 marginBottom={1}>
            <FormattedMessage id="admin.components.integrations.dsyncSetup.invitationEmailsmodal.title" />
          </H2>
          <Body marginBottom={3}>
            <FormattedMessage id={text} />
          </Body>
          <Flex>
            <Button onClick={onHide} marginRight>
              <FormattedMessage id="admin.components.integrations.setup.invitationEmailsmodal.button1" />
            </Button>
            <Button primary onClick={onConfirm} load={submit}>
              <FormattedMessage id={button} />
            </Button>
          </Flex>
        </>
      )}
    </GenericModal>
  )
}

export default injectIntl(InvitationEmailsModal)
